const HOME_ALERTS_TYPES = {
  SET_ON_INIT: 'SET_ON_INIT',
  SET_SELECTED_CATEGORY: 'SET_SELECTED_CATEGORY',
  SET_CLICKED_SELECTED_CATEGORY: 'SET_CLICKED_SELECTED_CATEGORY',
  SET_SELECTED_ALERT: 'SET_SELECTED_ALERT',
  // Sets selectedAlert and selectedCategory in one dispatch so no render
  // ever observes a category/alert pair from two different tabs.
  SET_SELECTED_ALERT_AND_CATEGORY: 'SET_SELECTED_ALERT_AND_CATEGORY',
  SET_SELECTED_ALERT_PARENT: 'SET_SELECTED_ALERT_PARENT',
  SET_LATEST_SIGNAL_R_NOTIFICATION: 'SET_LATEST_SIGNAL_R_NOTIFICATION',
  SET_SHOULD_GET_NEXT_ALERT: 'SET_SHOULD_GET_NEXT_ALERT',
  SET_IS_LAST_ALERT: 'SET_IS_LAST_ALERT',
  SET_UNDERWRITER_VERIFIED_RULE: 'SET_UNDERWRITER_VERIFIED_RULE',
  SET_IS_UNDERWRITER_CHECKBOX_DISABLED: 'SET_IS_UNDERWRITER_CHECKBOX_DISABLED',
  SET_IS_MENU_TOGGLE_COLLAPSED: 'SET_IS_MENU_TOGGLE_COLLAPSED',

  GET_GUTTER_ALERTS_STARTED: 'GET_GUTTER_ALERTS_STARTED',
  GET_GUTTER_ALERTS_SUCCESS: 'GET_GUTTER_ALERTS_SUCCESS',
  GET_GUTTER_ALERTS_ERROR: 'GET_GUTTER_ALERTS_ERROR',

  GET_NAVIGATION_ITEMS_STARTED: 'GET_NAVIGATION_ITEMS_STARTED',
  GET_NAVIGATION_ITEMS_SUCCESS: 'GET_NAVIGATION_ITEMS_SUCCESS',
  GET_NAVIGATION_ITEMS_ERROR: 'GET_NAVIGATION_ITEMS_ERROR',

  POST_TRIGGER_ALL_RULES_STARTED: 'POST_TRIGGER_ALL_RULES_STARTED',
  POST_TRIGGER_ALL_RULES_SUCCESS: 'POST_TRIGGER_ALL_RULES_SUCCESS',
  POST_TRIGGER_ALL_RULES_ERROR: 'POST_TRIGGER_ALL_RULES_ERROR',

  ADD_GUTTER_CALLBACK: 'ADD_GUTTER_CALLBACK',
  REMOVE_GUTTER_CALLBACK: 'REMOVE_GUTTER_CALLBACK',
  CLEAR_GUTTER_CALLBACKS: 'CLEAR_GUTTER_CALLBACKS',

  POST_GET_UNDERWRITER_VERIFICATION_STATUS_STARTED:
    'POST_GET_UNDERWRITER_VERIFICATION_STATUS_STARTED',
  POST_GET_UNDERWRITER_VERIFICATION_STATUS_SUCCESS:
    'POST_GET_UNDERWRITER_VERIFICATION_STATUS_SUCCESS',
  POST_GET_UNDERWRITER_VERIFICATION_STATUS_ERROR:
    'POST_GET_UNDERWRITER_VERiFICATION_STATUS_ERROR',

  POST_SAVE_UNDERWRITER_VERIFICATION_STARTED:
    'POST_SAVE_UNDERWRITER_VERIFICATION_STARTED',
  POST_SAVE_UNDERWRITER_VERIFICATION_SUCCESS:
    'POST_SAVE_UNDERWRITER_VERIFICATION_SUCCESS',
  POST_SAVE_UNDERWRITER_VERIFICATION_ERROR:
    'POST_SAVE_UNDERWRITER_VERIFICATION_ERROR',

  BAIL_OUT_AND_SUBMIT_TO_SETUP_STARTED: 'BAIL_OUT_AND_SUBMIT_TO_SETUP_STARTED',
  BAIL_OUT_AND_SUBMIT_TO_SETUP_SUCCESS: 'BAIL_OUT_AND_SUBMIT_TO_SETUP_SUCCESS',
  BAIL_OUT_AND_SUBMIT_TO_SETUP_ERROR: 'BAIL_OUT_AND_SUBMIT_TO_SETUP_ERROR',

  NEXT_ALERT: 'NEXT_ALERT',
  SET_UNDERWRITER_VIEW_PERMISSIONS: 'SET_UNDERWRITER_VIEW_PERMISSIONS',
};

export default HOME_ALERTS_TYPES;
